import { render, staticRenderFns } from "./ListPessoavinculoPage.vue?vue&type=template&id=b5bfc64e&"
import script from "./ListPessoavinculoPage.vue?vue&type=script&lang=js&"
export * from "./ListPessoavinculoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports